import { useSelector } from 'react-redux';

/**
 * @returns {import('models/auth.models').UserProfile}
 */
export function useUserProfile() {
    const { userProfile } = useSelector((state) => state.security);

    return userProfile;
}
